import FormFactura from "../componentes/FormFactura.vue";
import ListaFactura from "../componentes/ListaFactura.vue";
import ListaAbono from "../componentes/ListaAbono.vue";
import ListadoIvaEmitidos from "../componentes/ListadoIvaEmitidos.vue";

// Facturas entrantes
import ListaComisionEmpresa from "../componentes/ListaComisionEmpresa.vue";

const meta_nota = {
    Auth: true,
    nota: 1,
    lista: "lista-notas",
    form: "guardar-nota",
    abonos: "lista-nota-abonos",
    ///req_admin: true
};
const meta_factura = {
    Auth: true,
    nota: 0,
    lista: "lista-facturas",
    form: "guardar-factura",
    abonos: "lista-abonos",
    ///req_admin: true
};
const routes = [
    ...route("/guardar-factura", FormFactura, meta_factura),
    ...route("/lista-facturas", ListaFactura, meta_factura),
    ...route("/listado-iva-emitidas", ListadoIvaEmitidos, {
        Auth: true,
    }),
    ...route("/lista-abonos", ListaAbono, meta_factura),
    ...route("/guardar-nota", FormFactura, meta_nota),
    ...route("/lista-notas", ListaFactura, meta_nota),
    ...route("/lista-nota-abonos", ListaAbono, meta_nota),
    ...route("/lista-comision-empresa", ListaComisionEmpresa, {
        Auth: true,
    }),
    //Facturas entrantes
    
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;
